// GlobalErrorHandler.tsx
import Script from "next/script";
import React from "react";

export const GlobalErrorHandler: React.FC = () => {
  return (
    <Script id="global-error-handler" strategy="beforeInteractive">
      {`
        // Global error listener
        window.addEventListener('error', function(event) {
          if (window.newrelic && typeof window.newrelic.noticeError === 'function') {
            const errorObj = event.error || new Error(event.message + ' at ' + event.filename + ':' + event.lineno + ':' + event.colno);
            window.newrelic.noticeError(errorObj, {
              source: event.filename,
              lineno: event.lineno,
              colno: event.colno
            });
          }
        });

        // Global unhandled promise rejection listener
        window.addEventListener('unhandledrejection', function(event) {
          if (window.newrelic && typeof window.newrelic.noticeError === 'function') {
            const errorObj = event.reason instanceof Error ? event.reason : new Error(event.reason || 'Unhandled promise rejection');
            window.newrelic.noticeError(errorObj);
          }
        });
      `}
    </Script>
  );
};

export default GlobalErrorHandler;
